import React from 'react';
import { JBButton, JBUserAvatar } from '@jbhi-fi/lanyard-ui';
import { styles } from '../AccountDetails.css';
import { decodeHtml } from '../../../helpers/helpers';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import CrazyFont from '@jbhi-fi/lanyard-ui/font/CrazyFont';
export type UserDetailsProps = {
  firstName: string;
  lastName?: string;
  email: string;
  userPhoto?: string;
  className?: string;
  actions?: Array<React.ReactElement<typeof JBButton>>;
  avatarSize?: number;
  isPerks?: boolean;
  isHeader?: boolean;
  startDate?: Date | undefined;
};

const proportionalAvatarSize = window.innerWidth <= 390 ? 50 : 80;
export const UserDetails = ({
  firstName,
  lastName,
  email,
  userPhoto,
  className = '',
  actions,
  avatarSize = proportionalAvatarSize,
  isPerks,
  isHeader,
  startDate,
}: UserDetailsProps): JSX.Element => {
  return (
    <div className={`${styles.userDetailsContainer} ${className}`}>
      {isPerks ? (
        <div className={styles.perksMemberTag}>
          <CrazyFont className={styles.perksMemberTagText}>Perks Member</CrazyFont>
        </div>
      ) : null}
      <div className={styles.iconContainer}>
        <JBUserAvatar
          fontSize={avatarSize / 2}
          fontSizeUnit="px"
          name={`${firstName} ${lastName ?? ''}`}
          userPhoto={userPhoto}
          size={avatarSize}
        />
      </div>
      <div className={styles.userContactContainer({ isHeader: isHeader })}>
        <div className={styles.userDetailsHeadingContainer({ isHeader: isHeader })}>
          {isHeader ? (
            <>
              <CalloutFont className={styles.userDetailsHeading({ isHeader: isHeader })}>
                HI {decodeHtml(firstName)}!
              </CalloutFont>
            </>
          ) : (
            <h5 className={styles.userDetailsHeading({ isHeader: isHeader })}>
              {decodeHtml(`${firstName} ${lastName ?? ''}`)}
            </h5>
          )}

          {actions?.map((action, index) => React.cloneElement(action, { key: index }))}
        </div>
        {isPerks && startDate ? (
          <p className={styles.userDetailsText({ isPerks: isPerks })}>
            Joined{' '}
            {startDate?.toLocaleDateString('en-au', {
              month: 'short',
              year: 'numeric',
            }) ?? ''}
          </p>
        ) : isHeader ? null : (
          <p className={styles.userDetailsText({ isPerks: isPerks })}>{email}</p>
        )}
      </div>
    </div>
  );
};
